import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { setItem } from "~/es6/localstorage";
import { DEFAULT_REPORT_STATE, LS_NAME, LOCAL_USER } from "./constants";
import { IReportState, IReportSaveData } from "./interfaces";
import { checkDeleteDate, getId, transformBeToState } from "./utils";
import { IUserFeedbackItem } from "~/report/interfaces";

interface ISaveReportData {
	rusId: number;
	source: string;
	id: number;
	data: IReportSaveData;
}

interface IUpdateReportData {
	rusId: number;
	items: Array<IUserFeedbackItem>;
}

const DELETE_AFTER = 60 * 1000;

const reportSlice = createSlice({
	name: "report",
	initialState: DEFAULT_REPORT_STATE,
	reducers: {
		saveReportData: (state: IReportState, action: PayloadAction<ISaveReportData>) => {
			const { rusId, source, id, data } = action.payload;

			if (!(rusId in state.data)) {
				state.data[rusId] = {};
			}

			if (!(LOCAL_USER in state.data)) {
				state.data[LOCAL_USER] = {};
			}

			const saveId = getId(source, id);

			// ulozime
			state.data[rusId][saveId] = data;
			state.data[LOCAL_USER][saveId] = data;

			// ls
			setItem(LS_NAME, JSON.stringify(state.data));
		},
		updateDataWithBe: (state: IReportState, action: PayloadAction<IUpdateReportData>) => {
			const { rusId, items } = action.payload;

			if (!(rusId in state.data)) {
				state.data[rusId] = {};
			}

			if (!(LOCAL_USER in state.data)) {
				state.data[LOCAL_USER] = {};
			}

			const curGlobalKeys = Object.keys(state.data[LOCAL_USER]);
			const curUserKeys = Object.keys(state.data[rusId]);
			const beKeys: Array<string> = [];

			for (const item of items) {
				const itemId = getId(item.poi_source, item.poi_id);

				// seznam klicu
				beKeys.push(itemId);
				// ulozime
				state.data[LOCAL_USER][itemId] = transformBeToState(item);
				state.data[rusId][itemId] = transformBeToState(item);
			}

			// smazeme nepouzivane klice
			for (const oldGlobalKey of curGlobalKeys) {
				if (!beKeys.includes(oldGlobalKey) && checkDeleteDate(state.data[LOCAL_USER][oldGlobalKey].date, DELETE_AFTER)) {
					delete state.data[LOCAL_USER][oldGlobalKey];
				}
			}

			for (const oldKey of curUserKeys) {
				if (!beKeys.includes(oldKey) && checkDeleteDate(state.data[rusId][oldKey].date, DELETE_AFTER)) {
					delete state.data[rusId][oldKey];
				}
			}

			// ls
			setItem(LS_NAME, JSON.stringify(state.data));
		},
	},
});

export const { saveReportData, updateDataWithBe } = reportSlice.actions;
export default reportSlice.reducer;
